import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import { useNavigate } from 'react-router-dom';
import * as P from '@/constants/paths';
import useRegisterStore, {
  RegistrationTrack,
} from '@/hooks/useRegistrationStore';
import { useEffect } from 'react';

export const RegistrationMinorConsent = () => {
  const navigate = useNavigate();
  const { minorConsent, setMinorConsentAccept } = useRegisterStore();

  useEffect(() => {
    if (!minorConsent) {
      navigate(-1);
    }
  }, []);

  const primaryActionOnClick = () => {
    setMinorConsentAccept(true);
    navigate(P.REGISTRATION_TOS);
  };
  const secondaryActionOnClick = () => navigate(-1);

  return (
    <RegistrationScreen
      title="Minor Consent"
      description="Before registering a new kit, you will have to review results and recommendations for your most recent active kit."
      primaryActionLabel="OK"
      primaryActionOnClick={primaryActionOnClick}
      secondaryActionLabel="Back"
      secondaryActionOnClick={secondaryActionOnClick}
      hideBackButton
      checkForRegisterStore={RegistrationTrack.ConsentForm}
    />
  );
};
